/* MBG drop countdown — reusable for any Drop section with the countdown
   enabled. The merchant picks day/month/year/hour/minute/timezone from
   Theme Editor dropdowns (see mbg-drop-collection.liquid); Liquid has
   already checked the combination is a real calendar date before this
   markup is ever rendered, so this file only has to turn those parts
   into ONE absolute launch instant (computed once, not re-derived every
   tick) and count down to it. No external library, one setInterval per
   section ticking once a second, and it stops itself completely and
   swaps to the post-launch panel at zero — it never sits at
   00:00:00:00 forever. Works for any number of drop sections on a page
   without any section-specific code.

   Europe/London handling: rather than hand-rolling the UK's BST/GMT
   switchover dates (which change slightly year to year and are easy to
   get subtly wrong), this asks the browser's own timezone database —
   via Intl.DateTimeFormat — what the given wall-clock date/time in
   London actually corresponds to in UTC. It works by taking a first
   guess (treating the parts as if they were UTC), asking Intl what that
   guess looks like when rendered in Europe/London, and then correcting
   the guess by however far off that render is from the intended
   wall-clock time. That correction is exactly the UTC offset in effect
   for that date (+1h in BST, +0h in GMT), so this stays correct across
   the DST boundary without needing to know the rule that produced it. */
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-mbg-countdown-enabled="true"]');
  if (!sections.length) {
    return;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function londonPartsToUtcMs(year, month, day, hour, minute) {
    var guess = Date.UTC(year, month - 1, day, hour, minute);
    if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) {
      return guess;
    }
    try {
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
      var parts = {};
      formatter.formatToParts(new Date(guess)).forEach(function (part) {
        parts[part.type] = part.value;
      });
      var seenHour = parseInt(parts.hour, 10);
      if (seenHour === 24) {
        seenHour = 0;
      }
      var seenAsUtc = Date.UTC(
        parseInt(parts.year, 10),
        parseInt(parts.month, 10) - 1,
        parseInt(parts.day, 10),
        seenHour,
        parseInt(parts.minute, 10)
      );
      return guess + (guess - seenAsUtc);
    } catch (e) {
      return guess;
    }
  }

  function isValidCalendarDate(year, month, day) {
    var check = new Date(Date.UTC(year, month - 1, day));
    return (
      check.getUTCFullYear() === year &&
      check.getUTCMonth() === month - 1 &&
      check.getUTCDate() === day
    );
  }

  sections.forEach(function (section) {
    var year = parseInt(section.getAttribute('data-mbg-launch-year'), 10);
    var month = parseInt(section.getAttribute('data-mbg-launch-month'), 10);
    var day = parseInt(section.getAttribute('data-mbg-launch-day'), 10);
    var hour = parseInt(section.getAttribute('data-mbg-launch-hour'), 10);
    var minute = parseInt(section.getAttribute('data-mbg-launch-minute'), 10);
    var timezone = section.getAttribute('data-mbg-launch-timezone') || 'Europe/London';

    var preEl = section.querySelector('[data-mbg-countdown-prelaunch]');
    var postEl = section.querySelector('[data-mbg-countdown-postlaunch]');
    var countdownEl = section.querySelector('[data-mbg-countdown-display]');

    // Defense in depth: Liquid already validated this combination before
    // rendering, but if any of the parts are missing/unparseable, hide
    // just the numbers and leave the pre-launch copy showing rather than
    // display NaN or a broken countdown.
    if (
      isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute) ||
      !isValidCalendarDate(year, month, day)
    ) {
      if (countdownEl) {
        countdownEl.hidden = true;
      }
      if (window.console && window.console.warn) {
        window.console.warn('MBG drop countdown: invalid launch date/time configured in Theme Editor — showing coming-soon fallback instead.');
      }
      return;
    }

    var target = timezone === 'UTC'
      ? Date.UTC(year, month - 1, day, hour, minute)
      : londonPartsToUtcMs(year, month, day, hour, minute);

    var daysEl = section.querySelector('[data-unit="days"]');
    var hoursEl = section.querySelector('[data-unit="hours"]');
    var minutesEl = section.querySelector('[data-unit="minutes"]');
    var secondsEl = section.querySelector('[data-unit="seconds"]');

    function goLive() {
      if (countdownEl) {
        countdownEl.hidden = true;
      }
      if (preEl) {
        preEl.hidden = true;
      }
      if (postEl) {
        postEl.hidden = false;
      }
      /* Broadcast so anything else on the page tied to this same launch
         moment (e.g. the homepage hero's CTA, see mbg-campaign-hero.liquid)
         can flip too, without needing its own copy of the date logic or
         being inside this section. There's one authoritative drop launch
         time site-wide (settings.mbg_drop_launch_*), so one event covers
         every listener. */
      document.dispatchEvent(new CustomEvent('mbg:drop-launched'));
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        goLive();
        return false;
      }
      if (daysEl) {
        daysEl.textContent = pad(Math.floor(diff / 86400000));
      }
      if (hoursEl) {
        hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      }
      if (minutesEl) {
        minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      }
      if (secondsEl) {
        secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      return true;
    }

    if (!tick()) {
      return;
    }

    var interval = setInterval(function () {
      if (!tick()) {
        clearInterval(interval);
      }
    }, 1000);
  });

  /* Anything else on the page tied to this same launch moment (e.g. the
     homepage hero's CTA — see mbg-campaign-hero.liquid) flips the moment
     the countdown above actually reaches zero, with no page reload and no
     Theme Editor change needed at launch time. One real <a> the whole
     time — its href/label are updated in place from its own data
     attributes, never two elements toggled between hidden/visible, so
     there's no instant where both (or neither) label could show. */
  document.addEventListener('mbg:drop-launched', function () {
    document.querySelectorAll('[data-mbg-drop-cta]').forEach(function (el) {
      var label = el.getAttribute('data-postlaunch-label');
      var href = el.getAttribute('data-postlaunch-href');
      if (href) {
        el.setAttribute('href', href);
      }
      if (label) {
        var labelEl = el.querySelector('.mbg-hero__cta-label');
        if (labelEl) {
          labelEl.textContent = label;
        }
      }
    });
  });

    /* Hide the floating TrustedSite trustmark after 30 seconds. */
  window.setTimeout(function () {
    var selectors = [
      'iframe[src*="trustedsite" i]',
      '[id*="trustedsite" i]',
      '[class*="trustedsite" i]',
      '[data-trustedsite]',
      '[title*="trustedsite" i]',
      'a[href*="trustedsite.com" i]'
    ];

    var hiddenTargets = [];

    document.querySelectorAll(selectors.join(',')).forEach(function (node) {
      var target = node;
      var depth = 0;

      while (target && target !== document.body && depth < 6) {
        var position = window.getComputedStyle(target).position;
        if (position === 'fixed' || position === 'sticky') {
          break;
        }
        target = target.parentElement;
        depth += 1;
      }

      if (!target || target === document.body) {
        var nodePosition = window.getComputedStyle(node).position;
        if (nodePosition !== 'fixed' && nodePosition !== 'sticky') {
          return;
        }
        target = node;
      }

      if (hiddenTargets.indexOf(target) !== -1) return;
      hiddenTargets.push(target);

      target.style.setProperty('display', 'none', 'important');
      target.style.setProperty('visibility', 'hidden', 'important');
      target.style.setProperty('opacity', '0', 'important');
      target.setAttribute('aria-hidden', 'true');
    });
  }, 30000);

})();
